import type { ApiError } from '../../api/client';
import { useT } from '../../i18n';

export function SaveBar({
  dirty,
  busy,
  error,
  onSave,
  onReset,
}: {
  dirty: boolean;
  busy: boolean;
  error?: ApiError | null;
  onSave: () => void;
  onReset: () => void;
}) {
  const { t } = useT();
  return (
    <div className="sticky-save">
      <span className={`msg ${dirty ? 'dirty' : ''}`}>
        {error ? <span style={{ color: '#ff8a8f' }}>{error.message}</span> : dirty ? t('Hay cambios sin guardar') : t('Todo guardado')}
      </span>
      <button className="btn btn-ghost" disabled={!dirty || busy} onClick={onReset}>
        {t('Descartar')}
      </button>
      <button className="btn btn-primary" disabled={!dirty || busy} onClick={onSave}>
        {busy ? t('Guardando…') : t('Guardar')}
      </button>
    </div>
  );
}
